export const CommentActionEnum = Object.freeze({
    PERSIST: 'PERSIST',
    UNPERSIST: 'UNPERSIST'
});

export const DraftCommentStatusEnum = Object.freeze({
    RAISED: 'RAISED',
    COMMENT: 'COMMENT',
    REPLY: 'REPLY',
    RESOLVED: 'RESOLVED',
    DELETED: 'DELETED'
});

export const CommentFlag = Object.freeze({
    COMMENT: 'COMMENT',
    RAISED_COMMENT: 'RAISED_COMMENT',
    RESOLVED_COMMENT: 'RESOLVED_COMMENT',
    REJECTED_COMMENT: 'REJECTED_COMMENT'
});